export default "__VITE_ASSET__xNbN_$xc__"